const en = {
    locale: {
        en: "EN",
        it: "IT",
    },
    user: {
        profile: "User Profile",
        account: "Account",
        logout: "Logout",
        login: "Login",
        support: "Support",
        name: "Name",
        email: "Email",
        verified: "Email verified",
        modify: "Modify",
        save: "Save changes",
        resetPasswordMessage: "An email was sent to your email address with instructions to change your password",
        resendEmail: "Resend",
        resendEmailMessage: "An email was sent to your email address with instructions to verify your account. After verifying it, reload this page",
    },
    generic: {
        yes: "Yes",
        no: "No",
    },
    error: {
        page: "Error",
        forbidden: "Access Denied",
        notFound: "Page not found",
        notAuthenticated: "Not authenticated"
    },
    kptable: {
        filters: "Filters",
        apply: "Apply",
        reset: "Reset",
        show_columns: "Show columns",
        pager: {
            first: "First",
            last: "Last",
        },
        actions: "Actions",
        date: {
            short: "MM/DD/YYYY",
            long: "MM/DD/YYYY hh:mm a",
        },
        confirm: {
            title: "Confirmation",
            yes: "Yes",
            no: "No",
        },
        show: "Show",
        globalSelectionWarn1: "All elements on this page have been selected. ",
        globalSelectionWarn2: "All elements have been selected. ",
        globalSelectionWarnAll: "Select all elements",
        globalSelectionWarnNotAll: "Cancel selection",
        globalSelectionFilterWarn1: "(Any active filters will be considered)",
        globalSelectionFilterWarn2: "(Any active filters are considered)",
        genericFilterError: "You need to add a filter or modify the existing one",
    },
};
export default en;
